import { DeleteOutline } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';

import { updateStateAttribute } from '../helpers/helper';
import CLocalizedText from './CLocalizedText';
import CModal from './CModal';
import XDButton from './buttons/XDButton';

interface Props {
  onConfirm: () => void;
  showModal?: boolean; // Optional external modal control
  onCancel?: () => void;
  title?: string; // Optional title prop
}

interface State {
  showModal: boolean;
}

export default function CDeleteConfirmationButton({ onConfirm, showModal, onCancel, title }: Props) {
  const [state, setState] = useState<State>({ showModal: false });

  useEffect(() => {
    if (showModal) {
      updateStateAttribute<State>({ showModal: true }, setState);
    }
  }, [showModal]);
  const handleClose = () => {
    updateStateAttribute<State>({ showModal: false }, setState);
    // tell parent to hide the component so it can remount next time
    if (showModal !== undefined && onCancel) {
      onCancel();
    }
  };
  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <div className={'flex gap-2 items-center justify-center'}>
      {showModal === undefined && (
        <XDButton
          onClick={() => {
            updateStateAttribute<State>({ showModal: true }, setState);
          }}
        >
          <DeleteOutline style={{ fontSize: '24px' }} />
        </XDButton>
      )}

      <CModal onClose={handleClose} open={state.showModal}>
        <div className="flex flex-col gap-4">
          <h2 className="text-base font-semibold text-left">{title ?? 'Are you sure you want to delete this item?'}</h2>
          <div className="flex justify-end gap-2">
            <XDButton onClick={handleConfirm} className="bg-red-500 text-white px-3 py-1">
              <CLocalizedText dictKey={'accountDelete.modal.yesButton'} />
            </XDButton>
            <XDButton onClick={handleClose} className="bg-gray-300 text-black px-3 py-1">
              <CLocalizedText dictKey={'accountDelete.modal.cancelButton'} />
            </XDButton>
          </div>
        </div>
      </CModal>
    </div>
  );
}
